import React from 'react'
import formatNumberCommas from 'Utils/formatNumberCommas'

const QuantityInputCell: React.FC<any> = props => {
	const index = props.row.index
	const { canInput, onChange } = props.cell.column
	const { documentStatus, quantity, quantities } = props.row.original

	if (documentStatus === '10') {
		// if (isFixed) {
		return (
			<div className="d-flex justify-content-end">
				<input
					placeholder="กรุณากรอกจำนวน"
					disabled={canInput}
					type="text"
					className="form-control form-control-sm w-75"
					value={quantity}
					onChange={e => onChange(e.target.value, index)}
				/>
			</div>
		)
		// } else {
		// 	return (
		// 		<div className="d-flex justify-content-end">
		// 			<div>-</div>
		// 		</div>
		// 	)
		// }
	} else {
		// if (isFixed) {
		return (
			<div className="text-end">
				{quantities.map((item: any, index: number) => (
					<div key={index}>
						<div className="d-inline-block me-2 fs-4">x</div>
						<div className="d-inline-block text-kumopack-grey-900 fw-bolder fs-4 me-2">
							{formatNumberCommas(item.quantity ?? 0)}
						</div>
					</div>
				))}
			</div>
		)
		// } else {
		// 	return (
		// 		<div className="d-flex justify-content-end">
		// 			<div>-</div>
		// 		</div>
		// 	)
		// }
	}
}

export default QuantityInputCell
